<section class="opening-times show" id="oeffnungszeiten">
  <div class="inner">
    <div class="address">
      <div class="heading3">
        <picture>
          <source srcset="assets/images/addresse-white.webp" type="image/webp">
          <img src="assets/images/addresse-white.png" alt="Dart Rock Cafe Adresse">
        </picture>
        <div><span>Location</span><br>und Kontakt</div>
      </div>
      <div class="split">
        <div class="element">
          <div>Hier findest du uns</div>
          <div class="address">Hauptstrasse 46,<br>34253 Lohfelden</div>
        </div>
        <div class="element">
          <div>So erreichst du uns</div>
          <div>0561 515643</div>
        </div>
      </div>
    </div>
  </div>
</section>
